import { ConfiguredAlertsCountSubscription } from "../../graphql/generated/operations";

/**
 * @param {ConfiguredAlertsCountSubscription | undefined} data
 * @returns {number | undefined}
 */
export const formatter = (data) =>
  data?.alertSubscriptionsAggregate.aggregate?.count;
